/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PlanningStatus } from './planningStatus';

export type MandatePlanningStatus = PlanningStatus | null;
